import { render, staticRenderFns } from "./scrollTop.vue?vue&type=template&id=d2135732&scoped=true"
import script from "./scrollTop.vue?vue&type=script&lang=js"
export * from "./scrollTop.vue?vue&type=script&lang=js"
import style0 from "./scrollTop.vue?vue&type=style&index=0&id=d2135732&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2135732",
  null
  
)

export default component.exports